export const retailStoreData = {
  data() {
    return {
      // additional data for retail locations.
      // use to help with BOPIS selector on the /cart page,
      // since shopify API doesn't have a way to filter down loactions by pickup only, or store hours.
      locationsMeta: [
        {
          name: '74 Main St',
          hours: [
            'Mon - Thu | 11AM - 8PM',
            'Fri - Sat | 11AM - 9PM',
            'Sun | 11AM - 6PM',
          ],
          lat: 40.7674364,
          lon: -111.8939171,
          isPickupLocation: true,
        },
      ],
    };
  },
  methods: {
    combineShopifyLocationDataWithAdditionalData(shopifyLocationData) {
      shopifyLocationData.forEach((location) => {
        //find the same location based on name
        if (
          this.locationsMeta.some(
            (lm) => lm.name.toLowerCase() === location.name.toLowerCase()
          )
        ) {
          let foundLocationMeta = this.locationsMeta.find(
            (lm) => lm.name.toLowerCase() === location.name.toLowerCase()
          );
          //add the additional data to the original shopify object
          //console.log('found match.');
          location.hours = foundLocationMeta.hours;
          location.isPickupLocation = foundLocationMeta.isPickupLocation;
          location.lat = foundLocationMeta.lat;
          location.lon = foundLocationMeta.lon;
        } else {
          //console.log('using default additional data.');
          //if not match is found, set the additial location data to some default values
          location.hours = [];
          location.isPickupLocation = false;
          location.lat = null;
          location.lon = null;
        }
      });
      return shopifyLocationData;
    },
  },
};
